import { nameof } from "@libs/utils/name-of.utils.ts";
import { required } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";
import { ClaimDiagnosisChangeFormValues } from "@shared-types/acc/claim-diagnosis-change-values.type.ts";

export class ClaimPrimaryDiagnosisValidator extends Validator<ClaimDiagnosisChangeFormValues> {
  constructor() {
    super();

    this.forField(nameof("diagnosisSide"), required());
    this.forField(nameof("diagnosisKey"), required());
  }
}
